import React from "react";

const Footer = props => {
    const year = new Date().getFullYear();


    return (
    <footer className="footer py-4"style={{borderTop:'1px solid #b7b7b7'}}>
        <div className="container-fluid">
            <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap">
                    <p className="mb-0">Created by <a href="https://www.techgenius.co.za"  rel="noreferrer" target="_blank">techgenius.co.za</a></p>
                    <p className="mb-0">|</p>
                    <p className="mb-0">{`All rights reserved`}</p>
                    <p className="mb-0">|</p>
                    <p className="mb-0">{`Copyright ${year} © PSFA`}</p>
                    <p className="mb-0">|</p>
                    <p className="mb-0">{"Ver 1.000C.007"}</p>
            </div>
        </div>
</footer>
)};

export default Footer;